import React, { useEffect } from 'react';

import _ from 'lodash';
import { connect } from 'react-redux';

export const THREATMETRIX_ORG_ID = '8u0q6ob5';

const mapStateToProps = ({ lendingAPI }) => ({
    sessionID: _.get(lendingAPI, 'threatmetrix.data.tm_session_id')
});

const mapDispatchToProps = (dispatch) => ({
    activateThreatMetrix: () => dispatch({ type: 'page/ACTIVATE_THREATMETRIX' })
});

const ThreatMetrix = ({ sessionID, activateThreatMetrix }) => {
    useEffect(() => {
        const activate = () => activateThreatMetrix();
        activate();
    }, [activateThreatMetrix]);

    if (sessionID) {
        return (
            <iframe
                data-testid="threatmetrix"
                style={{
                    width: 100,
                    height: 100,
                    border: 0,
                    position: 'absolute',
                    top: '-5000px'
                }}
                title="Threatmetrix"
                src={`https://h.online-metrix.net/fp/tags?org_id=${THREATMETRIX_ORG_ID}&session_id=${sessionID}`}
            />
        );
    }

    return null;
};

export default connect(mapStateToProps, mapDispatchToProps)(ThreatMetrix);
